import React, { useContext, useState, useEffect } from "react";
import { auth, db } from "./firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

const AuthContext = React.createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [userPermissions, setUserPermissions] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Fetch user doc from Firestore
        const userDoc = await getDoc(doc(db, "users", user.uid));
        let userData = {};
        let userTypes = {};
        if (userDoc.exists()) {
          userData = userDoc.data();
          userTypes = userData.userTypes || {};
        }
        // Find all userTypes that are true
        const activeTypes = Object.keys(userTypes).filter(
          (type) => userTypes[type]
        );

        // Fetch permissions for each type from TpUserTypes
        let mergedPermissions = {};
        for (const type of activeTypes) {
          const typeDocName = type.charAt(0).toUpperCase() + type.slice(1);
          const typeDoc = await getDoc(doc(db, "TpUserTypes", typeDocName));
          if (typeDoc.exists()) {
            const perms = typeDoc.data().permissions || {};
            // Merge permissions: if any type grants view, allow it
            Object.keys(perms).forEach((area) => {
              if (!mergedPermissions[area]) mergedPermissions[area] = {};
              mergedPermissions[area].view =
                mergedPermissions[area].view || perms[area]?.view;
              mergedPermissions[area].edit =
                mergedPermissions[area].edit || perms[area]?.edit;
            });
          }
        }

        setCurrentUser({ ...user, ...userData, userTypes });
        setUserPermissions(mergedPermissions);
      } else {
        setCurrentUser(null);
        setUserPermissions({});
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const logout = async () => {
    await signOut(auth);
  };

  const value = {
    currentUser,
    userPermissions,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
